export default {
	"Progress.remainder": "剩餘"
}